import { SxProps, Theme } from "@mui/material/styles";

/**
 * Common styles used across the application
 */

export const serviceActionsSectionStyle: SxProps<Theme> = {
  border: "1px solid",
  borderColor: "divider",
  borderRadius: 1,
  minWidth: 0,
  px: 1,
  pb: 1.5,
  mb: 2,
};
